<template>
  <div v-show="isActive">
    <slot v-if="isMounted || isActive"></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      required: true
    },
    selected: {
      default: false
    },
    disabledTab: {
      default: false
    }
  },
  data() {
    return {
      isActive: false,
      isMounted: false
    };
  },
  computed: {
    href() {
      return "#" + this.title.toLowerCase().replace(/ /g, "-");
    }
  },
  mounted() {
    this.isActive = this.selected;
  }
};
</script>